<template>
  <b-card>
    <b-alert
      v-model="showErrorAlert"
      variant="danger"
      dismissible
      @dismissed="errorMsg = ''"
    >
      {{ errorMsg }}
    </b-alert>

    <div class="d-flex justify-content-between align-items-center mb-2">
      <daily-live-cash-info
        :cash-data="todayCashData"
        :selected-date="selectedDate"
        @date-changed="selectedDate = $event"
      />
      <div class="text-center">
        <h3 class="mb-0">
          Cash Register
        </h3>
      </div>
      <div class="d-flex align-items-center">
        <opening-balance @data-updated="fetchAllLiveData" />
        <closing-balance @data-updated="fetchAllLiveData" />
        <b-button
          variant="primary"
          size="sm"
          class="ml-2"
          :disabled="isRefreshing"
          @click="fetchAllLiveData"
        >
          <b-spinner
            v-if="isRefreshing"
            small
          />
          <feather-icon
            v-else
            icon="RefreshCwIcon"
          />
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          class="ml-1"
          @click="isReportModal = true"
        >
          <feather-icon
            icon="FileTextIcon"
          />
        </b-button>
      </div>
    </div>
    <div class="position-relative">
      <b-tabs v-model="activeTab">
        <b-tab title="Bills">
          <received-bill-amount
            ref="receivedBillAmountRef"
            @data-updated="fetchAllLiveData('receivedBillAmountRef')"
          />
        </b-tab>
        <b-tab title="Expenses">
          <expenses
            ref="expensesRef"
            @data-updated="fetchAllLiveData('expensesRef')"
          />
        </b-tab>
        <b-tab title="Loan">
          <loans
            ref="loansRef"
            @data-updated="fetchAllLiveData('loansRef')"
          />
        </b-tab>
        <b-tab title="Received">
          <received-amount
            ref="receivedAmountRef"
            @data-updated="fetchAllLiveData('receivedAmountRef')"
          />
        </b-tab>
        <b-tab title="MR Loan">
          <mr-loans
            ref="mrloansRef"
            @data-updated="fetchAllLiveData('mrloansRef')"
          />
        </b-tab>
      </b-tabs>

      <!-- Calculator Button with absolute position -->
      <div
        class="calculator-button-wrapper cursor-pointer"
        style="position: absolute; top: 10px; left: 32rem;"
        @click="isCalculatorOpen = true"
      >
        <b-icon-calculator
          v-b-tooltip.hover
          font-scale="1.3"
          variant="primary"
          title="Open Calculator (Press F7)"
        />
        <small
          style="font-size: 0.7rem;"
        >(press F7)</small>
      </div>
    </div>
    <cash-register-report-modal
      v-if="isReportModal"
      v-model="isReportModal"
    />
    <calculator-modal v-model="isCalculatorOpen" />
  </b-card>
</template>

<script>
import DailyLiveCashInfo from '@/components/Operations/CashRegister/DailyLiveCashInfo.vue'
import {
  BCard, BTab, BTabs, BAlert, BButton, BSpinner, VBTooltip,
  BIconCalculator,
} from 'bootstrap-vue'
import Expenses from '@/components/Operations/CashRegister/Expenses.vue'
import Loans from '@/components/Operations/CashRegister/Loans.vue'
import OpeningBalance from '@/components/Operations/CashRegister/OpeningBalance.vue'
import ClosingBalance from '@/components/Operations/CashRegister/ClosingBalance.vue'
import ReceivedAmount from '@/components/Operations/CashRegister/ReceivedAmount.vue'
import ReceivedBillAmount from '@/components/Operations/CashRegister/ReceivedBillAmount.vue'
import axios from 'axios'
import getParsedQueryString from '@/utils/headerQueryParser'
import dateMixin from '@/mixins/dateMixin'
import CashRegisterReportModal from '@/components/Operations/CashRegister/CashRegisterReportModal.vue'
import CalculatorModal from '@/components/Operations/CashRegister/CalculatorModal.vue'
import MrLoans from '@/components/Operations/CashRegister/MrLoans.vue'

export default {
  components: {
    DailyLiveCashInfo,
    OpeningBalance,
    ClosingBalance,
    BCard,
    BTab,
    BTabs,
    BAlert,
    BButton,
    BIconCalculator,
    BSpinner,
    Expenses,
    Loans,
    ReceivedAmount,
    ReceivedBillAmount,
    CashRegisterReportModal,
    CalculatorModal,
    MrLoans,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [dateMixin],
  data() {
    return {
      activeTab: 0,
      todayCashData: {},
      selectedDate: this.formatedDate(new Date(), 'YYYY-MM-DD'),
      errorMsg: '',
      showErrorAlert: false,
      isRefreshing: false,
      refreshInterval: null,
      isReportModal: false,
      isCalculatorOpen: false,
    }
  },
  watch: {
    selectedDate() {
      this.fetchTodayCashData()
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyPress)
    this.fetchAllLiveData()
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyPress)
  },
  methods: {
    handleKeyPress(e) {
      if (e.key === 'F7') {
        e.preventDefault()
        this.isCalculatorOpen = true
      } else if (e.key === 'Escape' && this.isCalculatorOpen) {
        this.isCalculatorOpen = false
      }
      const { activeElement } = document
      const isInputFocused = activeElement && (
        activeElement.tagName === 'INPUT'
        || activeElement.tagName === 'TEXTAREA'
        || activeElement.tagName === 'SELECT'
        || activeElement.isContentEditable
      )

      if (isInputFocused) {
        const value = activeElement.value || activeElement.textContent || ''
        const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length

        if (wordCount > 0) {
          return
        }
      }

      if (e.key === 'ArrowLeft' && this.activeTab > 0) {
        this.activeTab -= 1
      } else if (e.key === 'ArrowRight' && this.activeTab < 3) {
        this.activeTab += 1
      }

      if (e.key === 'F7') {
        e.preventDefault()
        this.isCalculatorOpen = true
      } else if (e.key === 'Escape' && this.isCalculatorOpen) {
        this.isCalculatorOpen = false
      }
    },

    async fetchTodayCashData() {
      try {
        this.isRefreshing = true
        this.errorMsg = ''
        this.showErrorAlert = false

        const response = await axios.get(`/operations/todays_cash?${getParsedQueryString({ date: this.selectedDate })}`)
        this.todayCashData = response.data
      } catch (error) {
        this.errorMsg = error.response?.data?.msg || error.message || 'Failed to fetch today cash data'
        this.showErrorAlert = true
      } finally {
        this.isRefreshing = false
      }
    },

    async fetchAllLiveData(skipRefName = null) {
      try {
        this.isRefreshing = true
        this.errorMsg = ''
        this.showErrorAlert = false

        const response = await axios.get(`/operations/todays_cash?${getParsedQueryString({ date: this.selectedDate })}`)
        this.todayCashData = response.data

        // Call fetchData method in all child components EXCEPT the one that triggered the update
        await this.fetchChildComponentsData(skipRefName)
      } catch (error) {
        this.errorMsg = error.response?.data?.msg || error.message || 'Failed to fetch today cash data'
        this.showErrorAlert = true
      } finally {
        this.isRefreshing = false
      }
    },

    async fetchChildComponentsData(skipRefName = null) {
      const childRefs = [
        'receivedBillAmountRef',
        'expensesRef',
        'loansRef',
        'mrloansRef',
        'receivedAmountRef',
      ]

      const fetchPromises = childRefs
        .filter(refName => refName !== skipRefName)
        .map(refName => {
          const childComponent = this.$refs[refName]
          if (childComponent && typeof childComponent.fetchData === 'function') {
            return childComponent.fetchData()
          }
          return Promise.resolve()
        })

      await Promise.all(fetchPromises)
    },
  },
}
</script>

<style scoped>
.text-center {
  flex: 1;
}

.cursor-pointer {
  cursor: pointer;
  transition: opacity 0.2s;
}

.cursor-pointer:hover {
  opacity: 0.7;
}

.calculator-button-wrapper {
  display: flex;
  align-items: center;
  z-index: 10;
}
</style>
